import React, { useEffect, useRef } from "react";
import { useSearchBox } from "react-instantsearch-hooks-web";

function SearchInput({ onModeChange, resetToken = 0, placeholder = "Search Drive" }) {
	const { query, refine } = useSearchBox();
	const lastResetTokenRef = useRef(resetToken);

	useEffect(() => {
		if (lastResetTokenRef.current === resetToken) {
			return;
		}

		lastResetTokenRef.current = resetToken;
		if (query) {
			refine("");
			onModeChange(false);
		}
	}, [resetToken, query, refine, onModeChange]);

	function handleChange(e) {
		const nextQuery = e.target.value;
		if (typeof onModeChange === "function") {
			onModeChange(nextQuery.trim().length > 0);
		}
		refine(nextQuery); // important: update query AFTER toggling mode
	}

	console.log("Query:", query);


	return (
		<input
			className="form-control"
			placeholder={placeholder}
			type="text"
			value={query}
			onChange={handleChange}
		/>
	);
}

export default SearchInput;
